import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Facility } from "@liveline/ll_node_common/lib/models/api/facility";

export const facilityReducer = createSlice({
    name: "facility",
    initialState: null as Facility | null,

    reducers: {
        setFacility: (state, action: PayloadAction<Facility>) => {
            // Update selected facility
            return action.payload;
        },
    },
});

// Action creator
export const { setFacility } = facilityReducer.actions;

export default facilityReducer.reducer;
